import { Colors } from '../constants/colors';
import { GAME_WIDTH } from '../constants/constants';
import { LANGUAGES } from '../constants/languages';
import { Scenes } from '../constants/scenes';
import { GameState } from '../types/game-state';

export function languageSelectionScene() {
  scene(Scenes.LANGUAGE_SELECTION, (gameState: Pick<GameState, 'playerColor'>) => {
    debug.log('in language selection');

    add([
      text('Pick your language', { font: 'arial', width: 600 }),
      color(...Colors.BLACK),
      // put into middle top of the screen
      pos(GAME_WIDTH / 2 - 150, 50),
    ]);

    // List out language buttons in 2 columns
    const buttonWidth = 200;
    const buttonHeight = 60;
    const buttonSpacingX = 40;
    const buttonSpacingY = 30;
    const columns = 2;
    const startY = 120;
    const totalWidth = columns * buttonWidth + (columns - 1) * buttonSpacingX;
    const startX = GAME_WIDTH / 2 - totalWidth / 2;

    LANGUAGES.forEach((lang, i) => {
      const col = i % columns;
      const row = Math.floor(i / columns);
      const x = startX + col * (buttonWidth + buttonSpacingX);
      const y = startY + row * (buttonHeight + buttonSpacingY);
      add([
        rect(buttonWidth, buttonHeight, { radius: 8 }),
        color(...Colors.WHITE),
        pos(x, y),
        area(),
        outline(2, rgb(...Colors.BLACK)),
        'language-btn',
        { lang },
        z(1),
      ]);
      add([
        text(
          (() => {
            const [firstLetter, ...restLang] = [...lang];
            return [firstLetter.toUpperCase(), ...restLang].join('');
          })(),
          { font: 'arial', size: 32, width: buttonWidth, align: 'center' },
        ),
        color(...Colors.BLACK),
        pos(x + buttonWidth / 2, y + buttonHeight / 2),
        anchor('center'),
        z(2),
      ]);
    });

    onClick('language-btn', (btn) => {
      debug.log(`selected language: ${btn.lang}`);
      go(Scenes.CROWD_CUT, {
        playerKnownLanguage: btn.lang,
        ...gameState,
      } as Partial<GameState>);
    });
  });
}
